import { memo, useEffect, useState } from 'react';

import { DatePicker } from 'antd';

import dayjs from 'dayjs';

import { DATE_FORMAT } from '../../constants/common';

function AppTableDatepicker({ col, record, value, handleChange }) {
  const [selectedValue, setSelectedValue] = useState('');

  const disabled = col.editConfig?.disabledToEdit?.(record) ?? false;
  const dateFormat = DATE_FORMAT.DATE;

  useEffect(() => {
    const dateValue = value ? dayjs(value) : null;
    setSelectedValue(dateValue);
  }, [value]);

  const minDate =
    col.editConfig.minDate && record[col.editConfig.minDate]
      ? dayjs(record[col.editConfig.minDate], DATE_FORMAT.ISO_8601)
      : null;

  const handleOnChange = newValue => {
    setSelectedValue(newValue);
    handleChange({ ...record, [col.dataIndex]: newValue });
  };

  return (
    <DatePicker
      className="w-full"
      size="small"
      variant="borderless"
      allowClear={!!col.editConfig?.allowClear}
      value={selectedValue}
      disabled={disabled}
      disabledDate={col.editConfig.disabledDate}
      format={dateFormat}
      minDate={minDate}
      onChange={handleOnChange}
    />
  );
}

export default memo(AppTableDatepicker);
